import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';

import TuneIcon from '@mui/icons-material/Tune';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { COLOR_GREY_200, COLOR_GREY_600 } from 'src/colors';

const ToggleVisibilityButton = ({
  actionOnClick,
  isDisabled,
  isLocked,
  Icon,
  title,
}: {
  actionOnClick: () => void;
  isDisabled?: boolean;
  isLocked: boolean;
  Icon?: any;
  title?: any;
}) => {
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down(900));
  const [showHelperText, setShowHelperText] = useState(false);

  const buttonIconStyle = { px: '0 !important', margin: '0 !important' };

  return (
    <Button
      size="small"
      onClick={() => !isDisabled && actionOnClick()}
      disabled={isDisabled}
      onMouseEnter={() => !isMobileDevice && setShowHelperText(true)}
      onMouseLeave={() => !isMobileDevice && setShowHelperText(false)}
      sx={{
        background: COLOR_GREY_200,
        color: COLOR_GREY_600,
        fontSize: '16px',
        minWidth: '50px',
        width: showHelperText ? '200px' : '50px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        transition: 'width 0.25s ease, background 0.25s ease, color 0.25s ease',
        '&:hover': {
          width: isMobileDevice ? '50px' : '200px',
          background: isMobileDevice ? COLOR_GREY_200 : '#222',
          color: isMobileDevice ? COLOR_GREY_600 : '#fff',
        },
      }}
    >
      {isLocked ? (
        <LockOutlinedIcon sx={{ px: '0 !important', margin: '0 !important' }} />
      ) : Icon ? (
        <Icon sx={buttonIconStyle} />
      ) : (
        <TuneIcon sx={buttonIconStyle} />
      )}
      {showHelperText && (
        <Typography variant="button" sx={{ opacity: showHelperText ? 1 : 0, overflow: 'hidden' }}>
          {title ? title : 'Configure'}
        </Typography>
      )}
    </Button>
  );
};

export default ToggleVisibilityButton;
